import { contracts } from '../../data/contracts'

export default {
	name: 'OLAND',
	shortName: 'OLAND',
	contractAddress: contracts[process.env.REACT_APP_NETWORK].olandAddress,
	url: 'http://lorem.com',
	logo: 'tokens/Oland.png'
}
